import Vue from 'vue'
import FxFiltreTemplate from '@/wikaz-core/ui/composants/base/FxFiltreTemplate'
import FxItemTemplate from '@/wikaz-core/ui/composants/base/FxItemTemplate'
import VxBase from '@/wikaz-core/ui/composants/base/VxBase'

Vue.component('fx-filtre-template', FxFiltreTemplate)
Vue.component('fx-item-template', FxItemTemplate)
Vue.component('vx-base', VxBase)